var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8327 46L28.5827 38.75C27.9716 38.1389 27.2216 37.8333 26.3327 37.8333C25.4438 37.8333 24.666 38.1667 23.9993 38.8333C23.3882 39.4444 23.0827 40.2222 23.0827 41.1667C23.0827 42.1111 23.3882 42.8889 23.9993 43.5L33.4993 53C34.1105 53.6111 34.8882 53.9167 35.8327 53.9167C36.7771 53.9167 37.5549 53.6111 38.166 53L57.0827 34.0833C57.6938 33.4722 57.9993 32.7222 57.9993 31.8333C57.9993 30.9444 57.666 30.1667 56.9994 29.5C56.3882 28.8889 55.6105 28.5833 54.666 28.5833C53.7216 28.5833 52.9438 28.8889 52.3327 29.5L35.8327 46ZM40.4993 73.3333C35.8882 73.3333 31.5549 72.4578 27.4993 70.7067C23.4438 68.9578 19.916 66.5833 16.916 63.5833C13.916 60.5833 11.5416 57.0555 9.79268 53C8.04157 48.9444 7.16602 44.6111 7.16602 40C7.16602 35.3889 8.04157 31.0556 9.79268 27C11.5416 22.9444 13.916 19.4167 16.916 16.4167C19.916 13.4167 23.4438 11.0411 27.4993 9.29C31.5549 7.54111 35.8882 6.66666 40.4993 6.66666C45.1105 6.66666 49.4438 7.54111 53.4993 9.29C57.5549 11.0411 61.0827 13.4167 64.0827 16.4167C67.0827 19.4167 69.4571 22.9444 71.206 27C72.9571 31.0556 73.8327 35.3889 73.8327 40C73.8327 44.6111 72.9571 48.9444 71.206 53C69.4571 57.0555 67.0827 60.5833 64.0827 63.5833C61.0827 66.5833 57.5549 68.9578 53.4993 70.7067C49.4438 72.4578 45.1105 73.3333 40.4993 73.3333Z",
    fill: "url(#paint0_linear_233_6720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_233_6720",
    x1: 40.4993,
    y1: 6.66666,
    x2: 40.4993,
    y2: 120.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5E29",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.5d2bdf18f44788dc0c3c0b7bf2bb10f2.svg";
export { ForwardRef as ReactComponent };